import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import Header from '../components/Header';
import ContentRow from '../components/ContentRow';
import { getActiveProfileId } from '../lib/utils';
import ContentModal from '../components/ContentModal';
import Footer from '../components/Footer';
import { Heart } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MyListPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalContentId, setModalContentId] = useState(null);
  const [modalSource, setModalSource] = useState(null);

  const fetchList = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/watchlist`, { params: { profile_id: getActiveProfileId() }, withCredentials: true });
      setItems(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchList(); }, [fetchList]);

  const handleListChanged = useCallback((contentId, added) => {
    if (!added) {
      setItems(prev => prev.filter(item => item.id !== contentId));
    } else {
      fetchList();
    }
  }, [fetchList]);

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(180deg, #11041F 0%, #382C4E 100%)' }} data-testid="mylist-page">
      <Header />
      <div className="pt-24 px-6 md:px-16 pb-20">
        <h1 className="text-2xl sm:text-3xl font-bold font-['Manrope'] text-white mb-8" data-testid="mylist-title">
          Ma Liste
        </h1>

        {loading ? (
          <div className="flex justify-center py-20">
            <div className="w-8 h-8 border-2 border-[#E9641A]/30 border-t-[#E9641A] rounded-full animate-spin" />
          </div>
        ) : items.length > 0 ? (
          <ContentRow title="" items={items} onOpenModal={(id, rect) => { setModalContentId(id); setModalSource(rect || null); }} onListChanged={handleListChanged} />
        ) : (
          <div className="text-center py-20" data-testid="empty-list">
            <Heart size={48} className="text-white/20 mx-auto mb-4" />
            <p className="text-white/50 text-lg mb-2">Votre liste est vide</p>
            <p className="text-white/30 text-sm">Ajoutez des films et séries pour les retrouver ici</p>
          </div>
        )}
      </div>
      <Footer />

      {modalContentId && (
        <ContentModal contentId={modalContentId} onClose={() => { setModalContentId(null); setModalSource(null); }} sourceRect={modalSource} />
      )}
    </div>
  );
}
